import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Transition as _Transition, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "base-dialog-content-wrapper" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-row justify-center"
}
const _hoisted_3 = { class: "c-magic-line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogDescription = _resolveComponent("DialogDescription")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    appear: "",
    show: _ctx.isOpen,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        open: _ctx.isOpen,
        class: "fixed inset-0 z-top-bar overflow-y-auto",
        "initial-focus": _ctx.confirmButtonElementRef,
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DialogOverlay, { class: "fixed inset-0 z-1 bg-black-30" })
              ]),
              _: 1
            }),
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "duration-300 ease-out transform",
              "enter-from": "opacity-0 scale-95",
              "enter-to": "opacity-100 scale-100",
              leave: "duration-200 ease-in transform",
              "leave-from": "opacity-100 scale-100",
              "leave-to": "opacity-0 scale-95",
              onAfterEnter: _ctx.onDialogOpen,
              onAfterLeave: _ctx.onDialogClosed
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.attrs.class || 'w-screen-95 p-30 mx-auto bg-white text-center relative z-1 sm:p-50 sm:w-screen-60 md:w-screen-50 md:p-80')
                }, [
                  _createVNode(_Transition, {
                    appear: "",
                    "enter-active-class": "animated fadeIn u-anim-dur-300 u-anim-delay-300"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        "aria-label": "close",
                        class: "absolute top-0 right-0 z-1 p-10 m-5 sm:m-gutter outline-none focus:outline-none",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                      }, [
                        _createVNode(_component_c_icon, {
                          name: "icon-plus",
                          "aria-hidden": "true",
                          class: "rotate-45"
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.title)
                    ? (_openBlock(), _createBlock(_component_DialogTitle, {
                        key: 0,
                        class: "mb-30 xl:mb-40"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.title), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DialogDescription, {
                    class: _normalizeClass({'mb-30': _ctx.description}),
                    innerHTML: _ctx.description
                  }, null, 8, ["class", "innerHTML"]),
                  (_ctx.confirmMethod !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("button", {
                          type: "button",
                          "aria-label": "close",
                          class: "text-dusty-grey mx-10",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                        }, [
                          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.cancelButton), 1)
                        ]),
                        _createElementVNode("button", {
                          ref: "confirmButtonElementRef",
                          type: "button",
                          class: "c-button mx-10",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
                        }, _toDisplayString(_ctx.confirmButton), 513)
                      ]))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "default", { close: _ctx.closeModal })
                ], 2)
              ]),
              _: 3
            }, 8, ["onAfterEnter", "onAfterLeave"])
          ])
        ]),
        _: 3
      }, 8, ["open", "initial-focus", "onClose"])
    ]),
    _: 3
  }, 8, ["show"]))
}